'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconList, iconListTag } from '@ni/nimble-components/dist/esm/icons/list';
import { wrap } from '../../utilities/react-wrapper';

export type { IconList };
export { iconListTag };
export const NimbleIconList = wrap(IconList);